import { Component } from "preact";
import { connectWithTranslations } from "../../../../common/helpers/translationsHelpers";
import AdvancedTimeFilter from "./AdvancedTimeFilter";
import { FILTER_TYPE, GTM_ID, GA4EVENT } from "../../../constants";
import actions from "../../../actions";
import IconSearchSolid from "../../../../common/components/icons/IconSearchSolid";

class AdvancedFilterTopDesktop extends Component {
    render({
        filter,
        time,
        onTimeFilterChanged,
        onEventNameChanged,
        translate,
        config,
        loadDefaultSettings,
        loadCustomSettings,
        settings,
        filterType,
    }) {
        return (
            <div class="fxs_c_top">
                <label class="fxs_c_event-search">
                    <IconSearchSolid />
                    <input
                        type="search"
                        value={filter.eventName}
                        onChange={(event) =>
                            onEventNameChanged(
                                event.target.value ? event.target.value : ""
                            )
                        }
                        placeholder={translate("AdvancedFilterEventNameLabel")}
                        data-gtmid={
                            config.tracking &&
                            GTM_ID.ADVANCED_FILTERS_EVENT_NAME
                        }
                        data-ga4event-clk-name={ config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                        data-ga4event-element = { config.tracking && GA4EVENT.ELEMENTS.ADVANCED_FILTERS_EVENT_NAME}

                    />
                </label>
                <div class="fxs_fRight">
                    <AdvancedTimeFilter
                        time={time}
                        onTimeFilterChanged={onTimeFilterChanged}
                        getButtonGtmId={(timeRange) =>
                            config.tracking &&
                            GTM_ID.ADVANCED_FILTERS_TIME_BUTTON(
                                timeRange.replace("TimeFilter_", "")
                            )
                        }
                        getButtonGa4Id={(timeRange) =>
                            config.tracking &&
                            GA4EVENT.ELEMENTS.ADVANCED_FILTERS_TIME_BUTTON(
                                timeRange.replace("TimeFilter_", "")
                            )
                        }
                        getDropdownButtonGtmId={() =>
                            config.tracking &&
                            GTM_ID.ADVANCED_FILTERS_TIME_DROPDOWN
                        }
                        getDropdownButtonGa4Id={() =>
                            config.tracking &&
                            GA4EVENT.ELEMENTS.ADVANCED_FILTERS_TIME_DROPDOWN
                        }
                        getDropdownOptionGtmId={(timeRange) =>
                            config.tracking &&
                            GTM_ID.ADVANCED_FILTERS_TIME_DROPDOWN_OPTION(
                                timeRange.replace("TimeFilter_", "")
                            )
                        }
                        getDropdownOptionGa4Id={(timeRange) =>
                            config.tracking &&
                            GA4EVENT.ELEMENTS.ADVANCED_FILTERS_TIME_DROPDOWN_OPTION(
                                timeRange.replace("TimeFilter_", "")
                            )
                        }
                        getCalendarButtonGtmId={() =>
                            config.tracking &&
                            GTM_ID.ADVANCED_FILTERS_CALENDAR_BUTTON
                        }
                        getCalendarButtonGa4Id={() =>
                            config.tracking &&
                            GA4EVENT.ELEMENTS.ADVANCED_FILTERS_CALENDAR_BUTTON
                        }
                        getCalendarContentGtmId={() =>
                            config.tracking &&
                            GTM_ID.ADVANCED_FILTERS_CALENDAR_CONTENT
                        }
                        getCalendarContentGa4Id={() =>
                            config.tracking &&
                            GA4EVENT.ELEMENTS.ADVANCED_FILTERS_CALENDAR_CONTENT
                        }
                        getGa4Name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                    />
                    <button
                        type="button"
                        onClick={loadCustomSettings}
                        data-gtmid={config.tracking && GTM_ID.FILTER_MY_FILTERS}
                        data-ga4event-clk-name={ config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                        data-ga4event-element = { config.tracking && GA4EVENT.ELEMENTS.FILTER_MY_FILTERS}

                        class={`fxs_btn fxs_btn_table_filter fxs_btn_xsmall ${
                            filterType === FILTER_TYPE.custom
                                ? " fxs_active"
                                : ""
                        }`}
                    >
                        <span>
                            <span>{translate("MyFilterLabel")}</span>
                        </span>
                    </button>
                    <button
                        type="button"
                        onClick={loadDefaultSettings}
                        data-gtmid={config.tracking && GTM_ID.FILTER_DEFAULTS}
                        data-ga4event-clk-name={ config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                        data-ga4event-element = { config.tracking && GA4EVENT.ELEMENTS.FILTER_DEFAULTS}

                        class={`fxs_btn fxs_btn_table_filter fxs_btn_xsmall ${
                            filterType === FILTER_TYPE.default ||
                            filterType === FILTER_TYPE.basic
                                ? " fxs_active"
                                : ""
                        }`}
                    >
                        <span>
                            <span>{translate("DefaultsFilterLabel")}</span>
                        </span>
                    </button>
                </div>
            </div>
        );
    }
}

export default connectWithTranslations(
    "config, settings",
    actions
)(AdvancedFilterTopDesktop);
